/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $GoalTypeAmountList = {
    type: 'array',
    contains: {
        type: 'GoalTypeAmount',
    },
} as const;
